<template>
  <div>
    <v-card style="border-radius:12px" :outlined="$vuetify.theme.isDark">
      <v-card-title primary-title>
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <div v-on="on" class="headline mb-0 text-truncate">{{item.title}}</div>
          </template>
          <span>{{item.title}}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <div v-on="on" class="subtitle-2 mb-0 pb-2 pt-1 text-truncate">{{item.sentence}}</div>
          </template>
          <span>{{item.sentence}}</span>
        </v-tooltip>
        <template v-if="!loading_done_items && all_done_items.length">
          <!-- todas as realizações/done-items do item -->
          <div style="overflow-x: auto; display: flex; flex-direction: row;" >
              <v-col cols="12" sm="5" md="4" lg="3" v-for="(di, idx) in all_done_items" :key="(di.id+idx+'666'+item.id)" :class="['px-3 py-1 my-2 mx-1', done_form_ids.length && done_form_ids.includes(di.done_form_id)? `grey darken-${done_form_ids.indexOf(di.done_form_id)}` : '']" align="center" justify="end" style="border: solid 1px #ddd; border-radius: 8px">
                <!-- {{di.answer}} -->
                <v-row justify="space-between" align="center" class="px-3">
                  <v-icon v-if="compileAnswer(di) && compileAnswer(di).icon" :color="compileAnswer(di).color">{{compileAnswer(di).icon}}</v-icon>
                  <v-rating readonly v-if="compileAnswer(di) && compileAnswer(di).stars" :value="Number(compileAnswer(di).stars)" dense :color="di.succeeded? 'light-green accent-4':'red'" background-color="grey lighten-1"></v-rating>
                  <v-icon v-if="compileAnswer(di) && compileAnswer(di).face" :color="compileAnswer(di).color">{{compileAnswer(di).face}}</v-icon>
                  <template v-if="compileAnswer(di) && compileAnswer(di).choosen">
                    <v-chip color="red lighten-5" v-for="(c,c_idx) in compileAnswer(di).choosen" :key="'cp'+c_idx" class="mr-1">{{c}}</v-chip>
                  </template>
                  <v-chip :color="di.succeeded? 'green lighten-4':'red lighten-5'" v-if="compileAnswer(di) && compileAnswer(di).option">{{compileAnswer(di).option}}</v-chip>
                  <div v-if="compileAnswer(di) && compileAnswer(di).inputed" :class="['font-weight-black black--text', di.input_kind == 'number'? di.succeeded? 'green--text' : 'red--text':'']">{{compileAnswer(di).inputed}}</div>
                  <div v-if="compileAnswer(di) && compileAnswer(di).custom" :class="['font-weight-black black--text text-truncate']">{{compileAnswer(di).custom}} </div>
                  <div v-if="compileAnswer(di) && compileAnswer(di).date" :class="['font-weight-black black--text', di.input_kind == 'number'? di.succeeded? 'green--text' : 'red--text':'']">{{compileAnswer(di).date | moment('DD/MM/YYYY')}}</div>
                  <v-spacer></v-spacer>
                  <v-divider vertical></v-divider>
                  <span :class="['pl-2 text-right', done_form_ids.includes(di.done_form_id)? 'white--text' : '']" style="font-size: 11px; cursor: pointer" @click.stop="handleDoneFormClick(di.done_form_id)">
                    {{di.created_at | moment('timezone', 'America/Sao_Paulo'," H:mm - DD/MM")}}
                  </span>
                </v-row>
              </v-col>
          </div>
        </template>
        <template v-if="loading_done_items">
          <v-col align="center">
            <card-loading></card-loading>
          </v-col>
        </template>
        
      </v-card-text>
      <v-card-actions v-if="false" class="justify-end">
        <v-btn flat text color="error">Cancelar</v-btn>
        <v-btn flat text color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'ItemSetupHistoric',
  props: {
    item: {
      type: Object,
    },
    done_form_ids: {
      type: Array,
    }
  },
  data() {
    return {
      key: null,
      loading_done_items: false,
      all_done_items: [],
    }
  },
  methods: {
    handleDoneFormClick(df_id){
      this.$emit('done-form-select', df_id)
    },
    compileAnswer(item) {
      switch (item.kind) {
        case 'thumb':
          switch (item.answer) {
            case '0':
              return {kind: item.kind, color: 'red', icon: 'mdi-thumb-down'}
              // return '<v-icon>mdi-thumb-down</v-icon>'
            break;
            case '1':
              return {kind: item.kind, color: 'red', icon: 'mdi-thumb-down'}
              // return '<v-icon>mdi-thumb-down</v-icon>'
            break;
            case '5':
              return {kind: item.kind, color: 'success', icon: 'mdi-thumb-up'}
            break
          }
        break;
        case 'rating':
          return {kind: item.kind, stars: item.answer}
        break
        case 'react':
          switch (item.answer) {
            case '1':
              return {kind: item.kind, color: 'red', face: 'mdi-emoticon-frown-outline'}
            break;
            case '2':
              return {kind: item.kind, color: 'red', face: 'mdi-emoticon-sad-outline'}
            break;
            case '3':
              return {kind: item.kind, color: 'amber', face: 'mdi-emoticon-neutral-outline'}
            break;
            case '4':
              return {kind: item.kind, color: 'blue', face: 'mdi-emoticon-outline'}
            break;
            case '5':
              return {kind: item.kind, color: 'success', face: 'mdi-emoticon-excited-outline'}
            break
          }
        break;
        case 'options':
          return {kind: item.kind, option: item.answer}
        break
        case 'checklist':
          return {kind: item.kind, choosen: item.answer.split(', ')}
        break
        case 'input':
          return {kind: item.kind, inputed: item.answer.substring(0,15)}
        break
        case 'date':
          return {kind: item.kind, date: item.answer}
        break
        case 'signature':
          return {kind: item.kind, icon: 'mdi-draw', color: 'ckb_purple'}
        break
        case 'custom_field':
          return {kind: item.kind, custom: item.answer? item.answer : ''}
        break
        default:
          return null
          break;
      }
    },
    
    getDoneItems(filter){
      this.loading_done_items = true
      Api.DoneItem.indexByForm(this.item.id, {...filter, ...this.dateStartEnd}).then(response => response.data).then(done_items => {
        done_items = done_items.data? done_items.data.map(i=> i.attributes) : done_items
        this.all_done_items = [...done_items] //, ...done_items, ...done_items, ...done_items, ...done_items, ...done_items, ...done_items, ...done_items, ]
        // this.report.form_ids = this.allForms.map(f=>f.id)
        // this.loadCard({...this.report})
      }).catch(err=> {
        console.log({err});
      }).finally(()=> {
        this.loading_done_items = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getDoneItems();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      solutionID: state => state.Solution.solutionID
    }),
    ...mapGetters({
      getFilter: 'Dashboard/getFilter',
      dateStartEnd: 'DateFilter/getStartEndDate',
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    },
    dateStartEnd(nv,ov) {
      console.log('get start end date changed');
      this.getDoneItems({...nv})
    },
  },
}
</script>

<style scoped>

</style>